// extracted by mini-css-extract-plugin
export default {"text":"FindMe_text__JDFM3"};